import { render, staticRenderFns } from "./importationTable.vue?vue&type=template&id=71d0153e"
import script from "./importationTable.vue?vue&type=script&lang=js"
export * from "./importationTable.vue?vue&type=script&lang=js"
import style0 from "./importationTable.vue?vue&type=style&index=0&id=71d0153e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports